import React from 'react';
import './ModalForm.css';
import FacebookLogin from 'react-facebook-login';
const FacebookID = process.env.REACT_APP_FBID

const FacebookLog = () =>{
const handleLoginSuccess = (response) => {
   console.log(response.profileObj);
 };
 
 const handleLoginFailure = (error) => {
   console.log(error)
 };
return(
   <span className='fb'>
  <FacebookLogin
    appId={FacebookID}
    autoLoad={false}
    textButton="   Facebook"
    fields="name,email,picture"
    cssClass="facebook-button rounded m-3 bg-primary text-white"
    onSuccess={handleLoginSuccess}
    onFailure={handleLoginFailure} 
    icon="fa-facebook"
  />
  </span>
);
}
export default FacebookLog;